import InfoMenu from '../InfoMenu'
import { Menu } from '@styled-icons/entypo'
import { useEffect, useRef } from 'react'

function HeaderMenu(props) {
	const ref = useRef()

	useEffect(() => {
		if (props.isInfoOpen) {
			props.setNavOpen(false)
			return document
				.querySelector('body')
				.classList.add('overflow-hidden')
		}
		return document
			.querySelector('body')
			.classList.remove('overflow-hidden')
	}, [props.isInfoOpen])

	useEffect(() => {
		const checkIfClickedOutside = e => {
			// If the menu is open and the clicked target is not within the menu,
			// then close the menu
			if (
				props.isInfoOpen &&
				ref.current &&
				!ref.current.contains(e.target)
			) {
				props.setInfoOpen(false)
			}
		}

		document.addEventListener('click', checkIfClickedOutside)

		return () => {
			// Cleanup the event listener
			document.removeEventListener('click', checkIfClickedOutside)
		}
	}, [props.isInfoOpen])

	return (
		<div ref={ref}>
			<div onClick={props.onBurgerClick}>
				<Menu
					className={`w-[24px] h-[24px] fill-dark-100 transition duration-300 cursor-pointer ${
						props.isInfoOpen && 'rotate-90'
					}`}
				/>
			</div>
			<InfoMenu
				animate={true}
				isOpen={props.isInfoOpen}
				className='fixed top-[35px] lg:top-[45px] bottom-0 left-0 w-full md:w-[355px] bg-white dark:bg-dark-300 z-0 flex flex-col justify-center drop-shadow-2xl'
			/>
		</div>
	)
}

export default HeaderMenu
